/*======================================================
SLIDERINIT.JS - Homepage Slider
====================================================== */

if (typeof bindEvent !== 'function') {
    function bindEvent(el, eventName, eventHandler) {
        if (el.addEventListener) {
            el.addEventListener(eventName, eventHandler, false);
        } else if (el.attachEvent) {
            el.attachEvent('on' + eventName, eventHandler);
        }
    }
}

// if (!$("script[src='" + iCreateObject.corpRoot + "scripts/libs/ios-slider/structure/1.3.43/$.iosslider.min.js']").length && !$("script[src='https://js.esolutionsgroup.ca/js/libs/ios_slider/structure/1.3.43/$.iosslider.min.js']").length) {
//     var script = document.createElement('script');
//     script.setAttribute('src', iCreateObject.corpRoot + 'scripts/libs/ios-slider/structure/1.3.43/$.iosslider.min.js');
//     script.setAttribute('type', 'text/javascript');
//     $('body').append(script);
// }

function decodeEntities(encodedString) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = encodedString;
    return textArea.value;
}

var isPaused = false;
function initSlider() {
    if ($.fn.rotating_banners) {
        $('#rotatingBannerContainer').rotating_banners('IOSSlider', {
            bannerSizeText: '',
            skin: 'basic',
            skinVersion: '3.2.0',
            fileManagerUrls: [ '/230002_FileManager/Plugin/FileManagerPlugin.js' ],
            useEsolFileManager: true,
            wrapperHTMLStructure: '<div class="ic-slider"><div id="rotatingBanners" class="bannerContainer slider rsDefault"></div></div><a role="button" class="prev" href="#" title="Previous Banner" style="cursor: pointer;"><span class="ic-sr-only">Previous Banner</span></a><a role="button" class="next" href="#" title="Next Banner" style="cursor: pointer;"><span class="ic-sr-only">Next Banner</span></a><div class="ic-slider-controls"><ul class="ic-slider-dot-pagination"></ul><a role="button" class="pause" href="#" title="Play/Pause Banner"><span class="ic-sr-only">Play/Pause Banner</span></a></div>',
            slideHTMLStructure: '<div class="bannerEdit slide {bannerTextContrast} {bannerTextPosition}"><a class="bannerImageLink" href="{onclickTarget}" target="{onclickWindow}" title="{title}"><div class="bannerImage"><img class="lazyBanner" data-src="{imageURL}" alt="{altText}" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" /></div></a><div class="bannerGradient"></div><div class="ic-slider-content ic-slider-text"><div class="ic-container-fluid"><div class="ic-slider-content-foreground">{bannerText}</div></div></div><div class="ic-slider-content ic-slider-caption"><div class="ic-slider-content-foreground">{bannerCaption}</div></div></div>',
            textAreas: [{
                id: 'bannerText',
                name: 'Banner Text'
            }, {
                id: 'bannerCaption',
                name: 'Banner Caption'
            }],
            imageResizerMode: 'fixed',
            imageResizerWidth: '1600px',
            imageResizerHeight: '700px',
            customFields: [

            ],
            enableCustomStyles: true,
            customStyles: [{
                id: 'bannerTextContrast',
                title: 'Banner Text Contrast',
                optionName: 'bannerContrast',
                options: [
                    {
                        id: 'rbLightContrast',
                        name: 'Light',
                        cssclass: 'btLight'
                    },
                    {
                        id: 'rbDarkContrast',
                        name: 'Dark',
                        cssclass: 'btDark'
                    }
                ]
            },
            {
                id: 'bannerTextPosition',
                title: 'Banner Text Position',
                optionName: 'bannerPosition',
                options: [{
                    id: 'rbLeftPosition',
                    name: 'Left',
                    cssclass: 'btLeft'
                }, {
                    id: 'rbCenterPosition',
                    name: 'Center',
                    cssclass: 'btCenter'
                }, {
                    id: 'rbRightPosition',
                    name: 'Right',
                    cssclass: 'btRight'
                }]
            }],
            //remove link editor button from banner text
            editorSettings: $.extend(iCreateObject.isSiteInICreateMode ? $.fn.tinyMCE_iCreate_defaults.standardBannerTextSettings : {},
                {
                    theme_advanced_blockformats: 'h2,p',
                    theme_advanced_buttons1: 'undo,redo,|,formatselect,removeformat,pastetext,pasteword,|,code',
                    theme_advanced_buttons2: '',
                    theme_advanced_buttons3: ''
                }
                // add custom class for banner text edit mode
                /* ,(iCreateObject.isSiteInICreateMode && !iCreateObject.isSiteInPreviewMode ?
                    { "theme_advanced_styles": (top.IcrtEditor3 ? "homepageBanner-largeText=homepageBanner-largeText;homepageBanner-smallText=homepageBanner-smallText;homepageBanner-Button=homepageBanner-Button" : "") } : {})
                    */
                    )
                }, iCreateObject);
            }
            $('#rotatingBannerContainer .slide .bannerImage').each(function () {
                var link = $(this);
                $.each(this.attributes, function (i, attrib) {
                    var name = attrib.name;
                    var value = attrib.value;
                    link.attr(name, decodeEntities(value));
                });
            });

            //remove <a> if href is empty
            $('#rotatingBanners .slide a.bannerImageLink').each(function () {
                if ($(this).attr('href') === '' | $(this).attr('href') === null) {
                    $(this).contents().unwrap('a.bannerImageLink');
                }
            });

            $('.ic-slider .slide').each(function (index, item) {
                var bannerTitle = $(item).find('.bannerImage').attr('title') ? $(item).find('.bannerImage').attr('title') : 'slide ' + index;
                $('.ic-slider-pagination, .ic-slider-dot-pagination').append('<li><a role="button" href="#" title="View: ' + bannerTitle + '">' + bannerTitle + '</a></li>');
                $('.ic-slider-pagination li:first-child, .ic-slider-dot-pagination li:first-child').addClass('current');
            });

            $('<div class="mobileBannerText" role="complementary" aria-label="Mobile Banner Text">').insertAfter('#ic-gal-slider-home');

            /* basic - default settings */
            $('.ic-slider').iosSlider({
                snapToChildren: true,
                scrollbar: false,
                desktopClickDrag: false,
                responsiveSlideContainer: true,
                responsiveSlides: true,
                infiniteSlider: true,
                autoSlide: true,
                autoSlideTimer: 5000,
                autoSlideTransTimer: 0,
                autoSlideHoverPause: true,
                navSlideSelector: $('#ic-gal-slider-home .ic-slider-pagination li, #ic-gal-slider-home .ic-slider-dot-pagination li'),
                navNextSelector: $('#ic-gal-slider-home .next'),
                navPrevSelector: $('#ic-gal-slider-home .prev'),
                onSliderLoaded: sliderShow,
                onSliderResize: sliderResize,
                onSlideChange: fadeSlideChange,
                onSlideComplete: rotateMobileText
            });

            //TEMP FIX; IF <=1 BANNER, PAUSE TO DEAL WITH THE ERROR WITH <=1 BANNER
            if ($('#rotatingBanners .slide') && $('#rotatingBanners .slide').length <= 1) {
                $('.slider-container').find('.ic-slider').iosSlider('autoSlidePause');
                $('.ic-slider-controls').removeClass('visible').addClass('hide');
                $('#ic-gal-slider-home .prev, #ic-gal-slider-home .next').removeClass('visible').addClass('hide');
            } else {
                rotateMobileText();
            }
            sliderResize();

            // Pause on next, prev, pagination click
            $('.ic-slider-dot-pagination a, #ic-gal-slider-home .next, #ic-gal-slider-home .prev').click(function (event) {
                event.preventDefault();
                $(this).closest('.slider-container').find('.ic-slider').iosSlider('autoSlidePause');
                $('#ic-gal-slider-home .ic-slider-controls .pause').addClass('paused');
                isPaused = true;
            });

            // if pause button
            $('#ic-gal-slider-home .next, #ic-gal-slider-home .prev, #ic-gal-slider-home .ic-slider-controls .pause').click(function (event) {
                event.preventDefault();
                if ($(this).hasClass('paused')) {
                    $(this).closest('.slider-container').find('.ic-slider').iosSlider('autoSlidePlay');
                    isPaused = false;
                } else {
                    $(this).closest('.slider-container').find('.ic-slider').iosSlider('autoSlidePause');
                    isPaused = true;
                }
                $(this).toggleClass('paused');
            });
        }

        if (iCreateObject.isSiteInICreateMode) {
            $(window).on('load', initSlider);
        } else {
            $(document).ready(initSlider);
        }

        var firstSlide = true;

        function fadeSlideChange(args) {
            $('.ic-fade .bannerImage, .ic-fade .ic-slider-text').css('display', 'none');
            $(args.currentSlideObject).children('.bannerImage, .ic-slider-text').fadeIn('1000');

            //banners with links.
            $('#rotatingBanners .slide a').attr('tabindex', '-1');
            if ($(args.currentSlideObject).find('a').length) {
                $(args.currentSlideObject).find('> a .bannerImage').fadeIn('1000');
                $(args.currentSlideObject).find('a').removeAttr('tabindex');
            }

            $('#rotatingBanners .slide').removeClass('current');
            $(args.currentSlideObject).addClass('current');

            $('.ic-slider-pagination li, .ic-slider-dot-pagination li').removeClass('current');
            $('.ic-slider-pagination li:eq(' + (args.currentSlideNumber - 1) + '), .ic-slider-dot-pagination li:eq(' + (args.currentSlideNumber - 1) + ')').addClass('current');
            if(!$(args.currentSlideObject).hasClass('linkReady')){
                if (isPaused === false) {
                    $('.slider-container').find('.ic-slider').iosSlider('autoSlidePause');
                }
                //Lazy load images on slide change
                $(args.currentSlideObject).find('.lazyBanner').Lazy({
                    afterLoad: function() {
                        $(args.currentSlideObject).addClass('linkReady');
                        if (isPaused === false) {
                            $('.slider-container').find('.ic-slider').iosSlider('autoSlidePlay');
                        }
                    }
                });
            }
            rotateMobileText();
        }

        function rotateMobileText() {
            if ($('#rotatingBanners .slide') && $('#rotatingBanners .slide').length <= 1) {
                $('.slider-container').find('.ic-slider').iosSlider('autoSlidePause');
                $('.ic-slider-controls').removeClass('visible').addClass('hide');
                $('#ic-gal-slider-home .prev, #ic-gal-slider-home .next').removeClass('visible').addClass('hide');
            } else {
                var textContainer = $('.mobileBannerText');
                var currentSlide = $('#ic-gal-slider-home .ic-slider').data('args').currentSlideNumber;
                if (typeof currentSlide === 'number' && isFinite(currentSlide)) { textContainer.children('.ic-slider-text:nth-child(' + currentSlide + ')').addClass('visible'); }

                if ($('#rotatingBanners .slide') && $('#rotatingBanners .slide').length > 1) {
                    if (!firstSlide) {
                        var previousSlide = $('#ic-gal-slider-home .ic-slider').data('args').prevSlideNumber;
                        textContainer.children('.ic-slider-text:nth-child(' + previousSlide + ')').removeClass('visible');
                    }
                    firstSlide = false;
                }
            }
        }

        // function slideChange(args) {
        //     $('#rotatingBanners .slide').removeClass('current');
        //     $(args.currentSlideObject).addClass('current');
        //     $('.ic-slider-pagination li, .ic-slider-dot-pagination li').removeClass('current');
        //     $('.ic-slider-pagination li:eq(' + (args.currentSlideNumber - 1) + '), .ic-slider-dot-pagination li:eq(' + (args.currentSlideNumber - 1) + ')').addClass('current');
        // }

        function sliderShow(args) {
            $('.ic-slider, .ic-slider-controls').addClass('visible');
            $('#ic-gal-slider-home .ic-slider-text').clone().appendTo('.mobileBannerText');
            $(args.currentSlideObject).addClass('current');
            $('#rotatingBanners .slide a').attr('tabindex', '-1');

            if ($(args.currentSlideObject).find('a').length) {
                $(args.currentSlideObject).find('a').removeAttr('tabindex');
            }

            //Lazy load initial images
            var slideShowTimeOut = (iCreateObject.isSiteInICreateMode) ? 500 : 0; // handles first slide in edit mode
            $('.slider-container').find('.ic-slider').iosSlider('autoSlidePause');  //pause on initial load

            setTimeout(function () {
                $(args.currentSlideObject).find('img.lazyBanner').Lazy({
                    afterLoad: function () {
                        $(args.currentSlideObject).addClass('linkReady');

                        if (isPaused === false) {
                            $('.slider-container').find('.ic-slider').iosSlider('autoSlidePlay');
                        }

                        touchPause();
                    }
                });
            }, slideShowTimeOut);
        }

        function sliderOrientationResize() {
            $('#ic-gal-slider-home .ic-slider').iosSlider('update');
        }

        function sliderResize() { }

        function touchPause() {
            // Pause banner if touch device
            if ($('html').hasClass('touch')) {
                $('.slider-container').find('.ic-slider').iosSlider('autoSlidePause');
            } else {
                $('.slider-container').find('.ic-slider').iosSlider('autoSlidePlay');
            }
        }

        //resize the gallery on orientation change if on mobile device, and delay by 1 second to offset loading race condition
        if ('onorientationchange' in window) { bindEvent(window, 'orientationchange', function () { setTimeout(function () { sliderOrientationResize(); }, 1000); }); }

        $(window).load(function () {
            if (!iCreateObject.isSiteInICreateMode || iCreateObject.isSiteInPreviewMode) {
                $('.bannerGradient').each(function () {
                    if ($(this).prevAll('.bannerImage').length > 0) { $(this).on('click', function (event) {
                        $(this).prevAll('.bannerImage').trigger(event);
                    }); }
                });

                $('.ic-slider-caption').each(function () {
                    if ($(this).text().trim().length === 0) { $(this).hide(); }
                });
            }
        });
